export default __webpack_public_path__ + "static/media/Digital environment.7ccf2a27.png";